/**
 * @generated SignedSource<<730097d6ae65b73af54d4da2e8d8c906>>
 * @relayHash 7ea059724811cea589537e314b11add7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 81051b9ef9e2b791f6b496bd28a23ed422f62b88a3e8eec5abb4c22716c6b69a

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type BoardIssueSubscription$variables = {
  atlassianAccountId: string;
  cloudId: string;
  events: ReadonlyArray<string>;
  projectIds: ReadonlyArray<string>;
};
export type BoardIssueSubscription$data = {
  readonly jira: {
    readonly onJirtBoardIssueSubscription: {
      readonly boardId: string | null | undefined;
      readonly cloudId: string;
      readonly issueId: string | null | undefined;
      readonly resource: string;
      readonly type: string;
    } | null | undefined;
  } | null | undefined;
};
export type BoardIssueSubscription = {
  response: BoardIssueSubscription$data;
  variables: BoardIssueSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "atlassianAccountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "events"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectIds"
},
v4 = [
  {
    "concreteType": "JiraSubscription",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "atlassianAccountId",
            "variableName": "atlassianAccountId"
          },
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "events",
            "variableName": "events"
          },
          {
            "kind": "Variable",
            "name": "projectIds",
            "variableName": "projectIds"
          }
        ],
        "concreteType": "JiraJirtBoardScoreIssueEventPayload",
        "kind": "LinkedField",
        "name": "onJirtBoardIssueSubscription",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "type"
          },
          {
            "kind": "ScalarField",
            "name": "resource"
          },
          {
            "kind": "ScalarField",
            "name": "boardId"
          },
          {
            "kind": "ScalarField",
            "name": "cloudId"
          },
          {
            "kind": "ScalarField",
            "name": "issueId"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "BoardIssueSubscription",
    "selections": (v4/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "BoardIssueSubscription",
    "selections": (v4/*: any*/)
  },
  "params": {
    "id": "81051b9ef9e2b791f6b496bd28a23ed422f62b88a3e8eec5abb4c22716c6b69a",
    "metadata": {},
    "name": "BoardIssueSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "fe89207b97768c1d05529ecc19effa77";

export default node;
